type Setter<T> = {
  set: (value: T) => void;
};

export default function appendFormDataFromUrl<T>(
  formData: Partial<T>,
  useForm: {
    setters: {
      [K in keyof T]: Setter<T[K]>;
    };
  }
): void {
  Object.entries(formData).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      useForm.setters[key as keyof T].set(value as T[keyof T]);
    }
  });
}
